import { useCallback } from "react";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanRoomChangeDisable = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { roomChangeDisable } = viewModel;

	const onSetRoomChangeDisable = useCallback(
		(input: boolean) => {
			onSetViewModel([{ key: "roomChangeDisable", value: { ...roomChangeDisable, value: input } }]);
		},
		[onSetViewModel, roomChangeDisable],
	);

	return {
		roomChangeDisable,
		onSetRoomChangeDisable,
	};
};
